import Icon from '../components/Icon.vue'

Icon.register({
  'venus-mars': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M564 0c6.6 0 12 5.4 12 12v79c0 7.2-5.9 12-12.1 12-3 0-6-1.1-8.4-3.5l-16.9-16.9-48.7 48.7c14 22.2 22.1 48.5 22.1 76.7 0 79.5-64.5 144-144 144-33.7 0-64.7-11.5-89.2-30.9 14.1-16.7 25-36 32.1-57.1 14.5 14.8 34.8 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.4 0-42.6 9.2-57.1 24-7.1-21.1-18.1-40.4-32.1-57.1 24.6-19.3 55.5-30.9 89.2-30.9 28.2 0 54.5 8.1 76.7 22.1l48.7-48.7-16.9-16.9c-7.5-7.6-2.2-20.5 8.5-20.5h79zM144 64c79.5 0 144 64.5 144 144 0 68.5-47.9 125.8-112 140.4v51.6h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-64.1-14.5-112-71.9-112-140.4 0-79.5 64.5-144 144-144zM144 288c44.1 0 80-35.9 80-80s-35.9-80-80-80-80 35.9-80 80 35.9 80 80 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/venus-mars.js
// module id = 2086
// module chunks = 0